import React from 'react'
import { Column } from 'components/common/layout'
import { FileInputBox, FileSelectedBox } from 'components/apply/file-input'
import { getUrlLastSegment } from 'utils/formatters'
import { uploadFile } from 'utils/handlers'
import { WithIdLink } from 'types/common'

export const FileUploader: React.FC<{
  files: WithIdLink[]
  onChange: (e: WithIdLink) => void
  onRemove: (id: number) => void
  isSelectable?: boolean // 파일을 라디오 버튼 형태로 선택할 수 있는지
  selected?: number | null
  onSelect?: (id: number) => void
  accept?: string[] | string
}> = ({
  files,
  onChange,
  onRemove,
  isSelectable = false,
  selected,
  onSelect,
  accept,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return
    const file = e.target.files[0]
    if (files.some((item) => getUrlLastSegment(item.link) === file.name)) {
      alert('중복된 파일입니다.')
      e.target.value = ''
      return
    }
    uploadFile(e, '/accounts/me/application-files').then((res) => {
      if (!res) return
      onChange(res)
    })
  }
  return (
    <Column style={{ gap: 8 }}>
      {files.map((item) => (
        <FileSelectedBox
          key={item.id}
          file={item}
          onRemove={() => onRemove(item.id)}
          isSelected={isSelectable ? selected === item.id : undefined}
          onSelect={
            isSelectable && onSelect ? () => onSelect(item.id) : undefined
          }
        />
      ))}
      <FileInputBox
        onChangeEvent={handleFileChange}
        isRecommendingPDF
        accept={accept}
      />
    </Column>
  )
}
